import request from '@/utils/request'

// 登陆页-登陆
export function login(data) {
    return request({
        url: '/api/usr/token',
        method: 'post',
        data
    })
}
// 登陆页-获取用户信息
export function getInfo() {
    return request({
        url: '/api/usr',
        method: 'get',
    })
}
// 内部检测报告-批量上传文件
export function uploadFile(data) {
    return request({
        url: '/file',
        method: 'post',
        data
    })
}
// 内部检测报告-文件列表
export function getFileList(data) {
    return request({
        url: '/file',
        method: 'get',
        params: data
    })
}
// 内部检测报告-删除文件
export function deleteFile(data) {
    return request({
        url: '/file/' + data,
        method: 'delete',
    })
}
// 内部检测报告-下载二维码
export function downloadFile(data) {
    return request({
        url: '/file/qrcode/' + data.date + "/" + data.fileName,
        method: 'get',
        responseType: 'blob',
    })
}
// 登出
export function logout() {
    return request({
        url: '/api/usr/logout',
        method: 'post',
    })
}
// 公共检测报告库-批量上传文件
export function uploadOutFile(data) {
    return request({
        url: '/out/file',
        method: 'post',
        data
    })
}
// 公共检测报告库-文件列表
export function getPublicFileList(data) {
    return request({
        url: '/out/file',
        method: 'get',
        params: data
    })
}
// 公共检测报告库-删除文件
export function deletePublicFile(data) {
    return request({
        url: '/file/' + data,
        method: 'delete',
    })
}
// 公共检测报告库-下载文件
export function downloadPublicFile(data) {
    return request({
        url: '/out/file/'+data,
        method: 'get',
        responseType: 'blob',
    })
}
// 公共检测报告库-预览文件
export function previewFile(data) {
    return request({
        url: data.url+'/file/preview/'+data.id,
        method: 'get',
        responseType: 'arraybuffer',
    })
}
// 公共检测报告库-设置文件标签
export function updateTag(data) {
    return request({
        url: '/out/file',
        method: 'put',
        data
    })
}
// 用户管理-获取用户列表
export function getUserList(data) {
    return request({
        url: '/api/usr/list',
        method: 'get',
        params: data
    })
}
// 用户管理-删除用户
export function deleteUser(data) {
    return request({
        url: '/api/usr/'+data,
        method: 'delete',
    })
}
// 用户管理-编辑用户
export function updateUser(data) {
    return request({
        url: '/api/usr',
        method: 'put',
        data
    })
}
// 用户管理-新增用户
export function createUser(data) {
    return request({
        url: '/api/usr',
        method: 'post',
        data
    })
}